import { render, staticRenderFns } from "./unitDenominators.vue?vue&type=template&id=64e3ea88&scoped=true"
import script from "./unitDenominators.vue?vue&type=script&lang=js"
export * from "./unitDenominators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3ea88",
  null
  
)

export default component.exports